import { fetchTPASettingsSuccess, updateTPASettingsSuccess } from './tpa-settings-actions';
export const INITIAL_STATE = {
    settings: {},
    translations: {},
};
const tpaSettingsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case updateTPASettingsSuccess.type:
        case fetchTPASettingsSuccess.type:
            // Replace each provided top-level slice wholesale (rather than lodash `merge`, which
            // deep-merges and so can never clear a setting the server dropped or an emptied nested
            // object). Both actions always carry the full server payload, so replace is correct.
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
export default tpaSettingsReducer;
//# sourceMappingURL=tpa-settings-reducer.js.map